import { API_HOST, getHttpGetOptions, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/administration`;
const getViewActivityEngagementEndpoint = (programmeExternalReference) =>
  `${getEndpoint()}/activity/${programmeExternalReference}`;
const getViewHashtagEngagementEndpoint = (programmeExternalReference) =>
  `${getEndpoint()}/hashtag/${programmeExternalReference}`;
const getViewHashtagOccurencesEndpoint = (programmeExternalReference) =>
  `${getEndpoint()}/hashtag/occurrence/${programmeExternalReference}`;
const getUploadAnswersEndpoint = () => `${getEndpoint()}/answer/capture`;

export const getViewActivityEngagementRequest = (programmeExternalReference) => [
  getViewActivityEngagementEndpoint(programmeExternalReference),
  getHttpGetOptions()
];

export const getViewHashtagEngagementRequest = (programmeExternalReference) => [
  getViewHashtagEngagementEndpoint(programmeExternalReference),
  getHttpGetOptions()
];

export const getViewHashtagOccurencesRequest = (programmeExternalReference) => [
  getViewHashtagOccurencesEndpoint(programmeExternalReference),
  getHttpGetOptions()
];

export const getUploadAnswersRequest = (answers) => [getUploadAnswersEndpoint(), getHttpPostOptions(answers)];
